export default "__VITE_ASSET__7c5e5594__"